import { SociosSocketEvent, type SocketsListener, useSocketEventListener, withRefreshStrategy } from '@capsicum/common';
import { type FC, useMemo } from 'react';

import { useGamificationListeners } from '../hooks';
import { type RewardPointsSnackbarProps } from '../models';

type GamificationSociosListenersProps = { snackbarComponent: FC<RewardPointsSnackbarProps> };

export const GamificationSociosListeners = ({ snackbarComponent }: GamificationSociosListenersProps) => {
	const { gamificationRewardEventHandler } = useGamificationListeners(snackbarComponent);

	const listeners = useMemo(
		() =>
			new Map<SociosSocketEvent, SocketsListener>([
				[
					SociosSocketEvent.GAMIFICATION_USER_REWARDED,
					withRefreshStrategy({ listener: gamificationRewardEventHandler })
				]
			]),
		[gamificationRewardEventHandler]
	);

	useSocketEventListener(listeners);

	return null;
};
